import { render } from "./animauxDetails.vue?vue&type=template&id=3bcc14d1"
import script from "./animauxDetails.vue?vue&type=script&lang=js"
export * from "./animauxDetails.vue?vue&type=script&lang=js"

import "../assets/css/besoins.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__